module.exports = __webpack_public_path__ + "static/media/threat_tokens_numbered.df528a9e.png";